import angular from "angular";
import Vue from "vue";
import "ngVue";

import ChangelogEntryView from "./ChangelogEntryView.vue";

export default angular
  .module("directives.changelogEntry", [])
  .directive("dcChangelogEntry", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcChangelogEntry", ChangelogEntryView),
      );
    },
  ]);
